var getSelectedText = function getSelectedText(block, selection) {
  var text = block.getText();
  var length = text.length;
  var start = selection.getStartOffset();
  var stop = selection.getEndOffset();
  return start <= length && stop <= length ? text.substring(start, stop) : '';
};

var getEditorStateSnapshot = function getEditorStateSnapshot(editorState) {
  var selection = editorState.getSelection();
  var key = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(key);
  var selectedText = getSelectedText(block, selection);
  return {
    selection: selection,
    content: content,
    block: block,
    selectedText: selectedText
  };
};

export default getEditorStateSnapshot;